import React, { useCallback, useEffect, useState } from 'react';
import { Button, List, Empty, Spin, message, Input, Tag, Divider } from 'antd';
import { EyeOutlined, PlusOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import api from '../api/client';

interface CompanyOrder {
  id: number;
  number: string | null;
  date: string | null;
  title: string;
  content: string;
  status: string;
  created_at: string;
  updated_at: string;
}

const STATUS_LABELS: Record<string, string> = {
  active: 'Действует',
  cancelled: 'Отменён',
  draft: 'Черновик',
};

const STATUS_COLORS: Record<string, string> = {
  active: 'success',
  cancelled: 'red',
  draft: 'default',
};

const CompanyOrdersPage: React.FC = () => {
  const navigate = useNavigate();
  const [orders, setOrders] = useState<CompanyOrder[]>([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState('');

  const load = useCallback(() => {
    setLoading(true);
    api.get('/company-orders', { params: { search: search || undefined } })
      .then(r => setOrders(r.data || []))
      .catch(() => message.error('Ошибка загрузки'))
      .finally(() => setLoading(false));
  }, [search]);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <h2 style={{ margin: 0 }}>Приказы</h2>
        <Button type="primary" icon={<PlusOutlined />} onClick={() => navigate('/company-orders/new')}>
          Добавить
        </Button>
      </div>

      <Input.Search
        placeholder="Поиск по номеру или названию"
        allowClear
        value={search}
        onChange={e => setSearch(e.target.value)}
        onSearch={load}
        style={{ marginBottom: 16, maxWidth: 400 }}
      />

      <List
        loading={loading}
        dataSource={orders}
        locale={{ emptyText: <Empty description="Нет приказов" /> }}
        renderItem={order => (
          <List.Item
            actions={[
              <Button icon={<EyeOutlined />} size="small" onClick={() => navigate(`/company-orders/${order.id}`)}>
                Открыть
              </Button>,
            ]}
          >
            <List.Item.Meta
              title={
                <span>
                  {order.title}
                  <Tag color={STATUS_COLORS[order.status] || 'default'} style={{ marginLeft: 8 }}>
                    {STATUS_LABELS[order.status] || order.status}
                  </Tag>
                </span>
              }
              description={
                <div style={{ fontSize: 13, color: '#888' }}>
                  {order.number && <span>№{order.number} · </span>}
                  {order.date && <span>{new Date(order.date).toLocaleDateString('ru-RU')} · </span>}
                  <span>обновлён: {new Date(order.updated_at).toLocaleDateString('ru-RU')}</span>
                </div>
              }
            />
          </List.Item>
        )}
      />
    </div>
  );
};

export default CompanyOrdersPage;
